module.exports = __webpack_public_path__ + "static/media/logo_rounded.14e5818b.png";